import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { getIdentifierForIterableItem } from '@app/shared/utilities/trackby.utility';
import { Material } from '@app/reports/material-demand/material.model';
import { Setting } from '@app/reports/report-settings/setting.model';

// naming could be improved as this seems to be only used for raw materials in dashboard settings dialog
@Component({
  selector: 'acs-auto-complete',
  templateUrl: './auto-complete.component.html'
})
export class AutoCompleteComponent implements OnInit {
  @Input() emptyMessage: string;
  @Input() productTypeId: string;
  @Input() required: boolean;
  @Input() setting: Setting;
  @Output() settingChange = new EventEmitter<any>();

  public getIdentifierForIterableItem = getIdentifierForIterableItem;
  public options: Array<Material>;

  ngOnInit(): void {
    this.emptyMessage = this.emptyMessage ? this.emptyMessage : 'No Items Found';
    this.required = this.required ? this.required : false; // uhh.. wut?
    this.options = this.setting.options;
  }

  public onOptionsChanged(option: Material): void {
    this.setting.value = option;
    this.setting.configs.displayText = option.name;
    this.settingChange.emit(this.setting);
  }

  public onSearchTextChanged(searchText: any): void {
    if (typeof searchText === 'string') {
      const settingOptions = this.setting.options;
      this.options = settingOptions.filter(
        (option: Material) =>
          option.number.toLowerCase().includes(searchText.toLowerCase()) &&
          option.productTypeId === this.productTypeId
      );
    }
  }

  public displayMaterialName(item: any): string {
    return item ? item.number + ' - ' + item.name : '';
  }
}
